import React from "react"

import { IconSize } from "shared/types/Icon"
import { ConditionalButton } from "shared/ui/buttons/ConditionalButton"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface ProductConfiguratorOptionIconProps {
  id?: string
  icon?: IconName
  iconSize?: IconSize
  iconClassName?: string
  onClick?: () => void
}

export const ProductConfiguratorOptionIcon = React.memo(
  ({
    id,
    icon,
    iconSize,
    iconClassName,
    onClick
  }: ProductConfiguratorOptionIconProps) => {
    if (!icon) {
      return null
    }

    return (
      <ConditionalButton
        id={id}
        isButton={!!onClick}
        onClick={onClick}
        className="product-configurator-option__icon"
      >
        <Icon name={icon} size={iconSize} className={iconClassName} />
      </ConditionalButton>
    )
  }
)
